import { ACTION_FETCH_PROMOTIONS } from '@/store/actions.type';
import { MUTATION_SET_PROMOTIONS } from '@/store/mutations.type';
import PromotionProxy from '@/proxies/promotion.proxy';

const state = {
  promotions: [],
  paging: {},
};

const getters = {
  promotions: (state) => state.promotions,
  pagingPromotions: (state) => state.paging,
};

const actions = {
  [ACTION_FETCH_PROMOTIONS](state, query = {}) {
    return PromotionProxy.promotions(query).then((res) => {
      state.commit(MUTATION_SET_PROMOTIONS, res.data);
    });
  },
};

const mutations = {
  [MUTATION_SET_PROMOTIONS](state, payload = {}) {
    state.promotions = payload?.rows || [];
    state.paging = payload || {};
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
